import { Directive, forwardRef } from '@angular/core';
import { NG_VALIDATORS, FormControl, AbstractControl, Validator, ValidationErrors } from '@angular/forms';

export function requiredTrim(control: AbstractControl): ValidationErrors | null {
    const value = control.value;

    if (!value || `${value}`.trim() === '') {
        return {
            required: true
        };
    }

    return null;
}

@Directive({
    // tslint:disable-next-line:directive-selector
    selector: '[requiredTrim]',
    providers: [{ provide: NG_VALIDATORS, useExisting: forwardRef(() => RequiredTrimValidatorDirective), multi: true }]
})
export class RequiredTrimValidatorDirective implements Validator {
    validate(control: FormControl): ValidationErrors | null {
        return requiredTrim(control);
    }
}

